var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScanFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 180,
    viewBox: "0 0 135 158",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_294_2694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.518 1.93103H8.65628C5.06643 1.93103 2.15628 4.84118 2.15628 8.43103V149.093C2.15628 152.683 5.06643 155.593 8.65628 155.593H126.518C130.108 155.593 133.018 152.683 133.018 149.093V8.43103C133.018 4.84118 130.108 1.93103 126.518 1.93103Z",
    stroke: "#F7941D",
    strokeWidth: 3,
    strokeDasharray: "17 17"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_294_2694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 180,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanFace);
export default __webpack_public_path__ + "static/media/scan_face.bb9512411db86ff01fd9dfb94636306c.svg";
export { ForwardRef as ReactComponent };